import QuestionnaireType from "../../../interfaces/feedback/QuestionnaireType";

// Ids are stored by the backend - never change or reuse an existing id, add a new one instead.

export const STUDENT_QUESTIONNAIRE: QuestionnaireType = {
  title: "Can you please answer a few questions about the usefulness of the Open4Feedback platform?",
  questions: [
    {
      id: "s_q1",
      text: "Did the platform enable easier communication with the teacher?",
      answers: [
        { id: "s_q1_a1", text: "Yes" },
        { id: "s_q1_a2", text: "No" },
        { id: "s_q1_a3", text: "Not sure" },
      ],
    },
    {
      id: "s_q2",
      text: "If you provided feedback “I am lost”, “Too hard”, or “Not clear”, would you have raised your hand even without the platform, or you would prefer to use the platform and stay anonymous?",
      answers: [
        { id: "s_q2_a1", text: "I haven’t provided feedback" },
        { id: "s_q2_a2", text: "Definitely yes" },
        { id: "s_q2_a3", text: "Probably yes" },
        { id: "s_q2_a4", text: "Probably not" },
        { id: "s_q2_a5", text: "Definitely not" },
      ],
    },
    {
      id: "s_q3",
      text: "Did the platform improve your understanding of the lecture, e.g. the teacher made some clarifications or changes based on feedback?",
      answers: [
        { id: "s_q3_a1", text: "Yes" },
        { id: "s_q3_a2", text: "No" },
        { id: "s_q3_a3", text: "Not sure" },
      ],
    },
    {
      id: "s_q4",
      text: "Did the platform increase your participation and engagement?",
      answers: [
        { id: "s_q4_a1", text: "Yes" },
        { id: "s_q4_a2", text: "No" },
        { id: "s_q4_a3", text: "Not sure" },
      ],
    },
  ],
};

export const TEACHER_QUESTIONNAIRE: QuestionnaireType = {
  title: "Can you please answer a few questions about the usefulness of the Open4Feedback platform?",
  questions: [
    {
      id: "t_q1",
      text: "Did the platform ‘break the wall of silence’ by enabling easy communication with students?",
      answers: [
        { id: "t_q1_a1", text: "Yes" },
        { id: "t_q1_a2", text: "No" },
        { id: "t_q1_a3", text: "Not sure" },
      ],
    },
    {
      id: "t_q2",
      text: "Did you make real time changes in your lecture/presentation based on feedback obtained through the platform?",
      answers: [
        { id: "t_q2_a1", text: "Yes" },
        { id: "t_q2_a2", text: "No" },
      ],
    },
    {
      id: "t_q3",
      text: "Did students’ participation and engagement increase as a result of using the platform?",
      answers: [
        { id: "t_q3_a1", text: "Yes" },
        { id: "t_q3_a2", text: "No" },
      ],
    },
    {
      id: "t_q4",
      text: "Were you surprised by any feedback that you received (e.g. you thought that everything was clear, but some students had difficulties understanding the material)?",
      answers: [
        { id: "t_q4_a1", text: "Yes" },
        { id: "t_q4_a2", text: "No" },
      ],
    },
    {
      id: "t_q5",
      text: "Will you use information from students’ feedback to modify and/or improve your lecture?",
      answers: [
        { id: "t_q5_a1", text: "Yes" },
        { id: "t_q5_a2", text: "No" },
      ],
    },
  ],
};
